const SKELETON_CARD_COUNT = 5;
const SKELETON_CARDS = Array.from({ length: SKELETON_CARD_COUNT }, (_, i) => i);

export function EventFeedSkeleton() {
    return (
        <div className="flex flex-col gap-4 overflow-hidden">
            {SKELETON_CARDS.map((index) => (
                <div
                    key={index}
                    className="skeleton-item-container rounded-lg p-1 pb-3 flex flex-col gap-3 @[280px]:p-2 @[280px]:flex-row @[280px]:items-center @[280px]:gap-2.5"
                >
                    <div className="aspect-video w-full flex-shrink-0 rounded-[6px] skeleton-item @[280px]:aspect-auto @[280px]:h-[94px] @[280px]:w-[145px] @[280px]:rounded" />
                    <div className="flex-1 flex flex-col gap-2 px-2 min-w-0 self-stretch justify-center @[280px]:gap-3 @[280px]:px-0">
                        <div className="h-4 w-full rounded skeleton-item" />
                        <div className="h-3 w-20 rounded skeleton-item" />
                    </div>
                </div>
            ))}
        </div>
    );
}
